
import { YOUTUBE_CLIENT_ID, YOUTUBE_AUTH_URL, YOUTUBE_SCOPES, REDIRECT_URI } from '../config';

// Déclenche le flux d'autorisation OAuth de Google
export const initiateYouTubeAuth = (clientId?: string) => {
  // Utiliser le clientId passé en paramètre, sinon utiliser la constante
  const googleClientId = clientId || YOUTUBE_CLIENT_ID;
  
  // Vérifier si la variable d'environnement est définie
  if (!googleClientId) {
    console.error("Erreur: Client ID n'est pas configuré");
    throw new Error("Google Client ID n'est pas configuré. Veuillez vérifier vos paramètres.");
  }

  // Générer un state aléatoire pour prévenir les attaques CSRF
  const state = Math.random().toString(36).substring(2, 15);
  // Stocker le state dans localStorage pour vérification au retour
  localStorage.setItem('youtube_auth_state', state);
  
  // Log pour le débogage
  console.log("Redirection URI:", REDIRECT_URI);
  console.log("Client ID utilisé:", googleClientId);

  const authUrl = new URL(YOUTUBE_AUTH_URL);
  authUrl.searchParams.append('client_id', googleClientId);
  authUrl.searchParams.append('redirect_uri', REDIRECT_URI);
  authUrl.searchParams.append('response_type', 'code');
  // Utiliser YOUTUBE_SCOPES (au pluriel) et le joindre en chaîne
  authUrl.searchParams.append('scope', YOUTUBE_SCOPES.join(' '));
  authUrl.searchParams.append('access_type', 'offline');
  authUrl.searchParams.append('prompt', 'consent');
  authUrl.searchParams.append('state', state);

  // Log pour le débogage
  console.log("URL d'authentification complète:", authUrl.toString());

  // Rediriger l'utilisateur vers l'URL d'authentification Google
  window.location.href = authUrl.toString();
};
